import "./future-plans.scss";
type FuturePlansPageProps = {};

const FuturePlansPage = (props: FuturePlansPageProps) => {
  return (
    <>
      <div className="future-plans page">
        <div className="future-plans__header page__header">
          <h1 className="future-plans__header__title page__header__title">
            БЪДЕЩИ ПЛАНОВЕ
          </h1>
        </div>
        <div className="future-plans__body">
          <h1 className="future-plans__body__title"> Личен план за развитие</h1>
          <ul className="future-plans__body__content">
            <li className="future-plans__body__content__item">
              <p>Развитие на професионалните знания и умения</p>
            </li>
            <li className="future-plans__body__content__item">
              <p>
                Повишаване на квалификацията чрез участие в различните нива на
                тази дейност
              </p>
            </li>
            <li className="future-plans__body__content__item">
              <p>Посещения на семинари и други форми на обучения:</p>
              <ul className="future-plans__body__content__item__sub-content">
                <li className="future-plans__body__content__item__sub-content__sub-item">
                  <p>Да усъвършенствам уменията си като педагог</p>
                </li>
                <li className="future-plans__body__content__item__sub-content__sub-item">
                  <p>
                    Да усъвършенствам уменията си в подбора и планирането на
                    подходящи иновационни методи, средства и материали
                  </p>
                </li>
                <li className="future-plans__body__content__item__sub-content__sub-item">
                  <p>
                    Да усъвършенствам уменията си да провокирам интереса на
                    учениците за търсене на повече и различни източници на
                    информация.
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default FuturePlansPage;
